<template>
  <HeaderActionButton :on-pressed="onPressed">
    <template #icon>
      <v-icon>mdi-cog-outline</v-icon>
    </template>
  </HeaderActionButton>
</template>

<script>
import HeaderActionButton from "@/views/home/components/HeaderActionButton.vue";
export default {
  name: "AlertSettingsButton",
  components: {
    HeaderActionButton,
  },
  methods: {
    onPressed() {
      this.$router.push({ name: "Fleet Alerts" });
    },
  },
};
</script>
